import { render, staticRenderFns } from "./ClassListGroup.vue?vue&type=template&id=4e47ee58&scoped=true"
import script from "./ClassListGroup.vue?vue&type=script&lang=js"
export * from "./ClassListGroup.vue?vue&type=script&lang=js"
import style0 from "./ClassListGroup.vue?vue&type=style&index=0&id=4e47ee58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e47ee58",
  null
  
)

export default component.exports